import React from "react";
import { Container } from "react-bootstrap";

import CardCoordenador from "../CardCoordenador/CardCoordenador";

import "./InformacoesCurso.css";

const InformacoesCurso = ({
	cursoSelecionado,
	coordenador,
	isMedicina = false,
	ggMode = false,
	titulo = "Informações do curso",
	subtitulo = "Confira as principais informações sobre o curso.",
}) => {
	if (!cursoSelecionado) return null;

	const informacoes = cursoSelecionado?.Informacoes;

	const modalidade =
		informacoes?.Modalidade?.Value === "Hibrido"
			? "Presencial"
			: informacoes?.Modalidade?.Value;

	const grau =
		informacoes?.Tipo?.Value === "Tecnologo"
			? "Tecnólogo"
			: informacoes?.Tipo?.Value;

	const duracao = informacoes?.Duracao?.Value;

	return (
		<section className="informacoesCurso">
			<Container>
				<div className="informacoesCurso-header">
					<h2 className="text-white">{titulo}</h2>
					<p className="text-white">{subtitulo}</p>
				</div>

				<div
					className={`informacoesCurso-grid ${
						isMedicina ? "informacoesCurso-grid--medicina" : ""
					}`}
				>
					{duracao && (
						<div className="informacoesCurso-card">
							<p>
								Conclusão em <strong>{duracao}</strong>
							</p>
						</div>
					)}

					{modalidade && (
						<div className="informacoesCurso-card">
							<p>
								Curso <strong>{modalidade}</strong>
							</p>
						</div>
					)}

					{grau && (
						<div className="informacoesCurso-card">
							<p>
								Formação em <strong>{grau}</strong>
							</p>
						</div>
					)}

					{isMedicina && (
						<div className="informacoesCurso-card">
							<p>
								Nota <strong>5</strong> de acordo com o CC/MEC
							</p>
						</div>
					)}
				</div>

				<div className="informacoesCurso-destaques">
					<div className="informacoesCurso-destaque informacoesCurso-destaque--curriculo">
						<span className="informacoesCurso-destaqueRotulo">
							ORGANIZAÇÃO DO CURSO
						</span>

						<h3>Currículo</h3>

						<p>
							Conheça os componentes curriculares, a organização dos períodos
							e a estrutura completa da formação.
						</p>

						<a
							href="#curriculo"
							className="informacoesCurso-curriculoBtn"
						>
							Ver currículo
						</a>
					</div>

					<div className="informacoesCurso-destaque informacoesCurso-destaque--coordenador">
						{coordenador ? (
							<CardCoordenador coordenadorSelecionado={coordenador} />
						) : (
							<div className="informacoesCurso-coordenadorVazio">
								<span className="informacoesCurso-destaqueRotulo">
									COORDENAÇÃO
								</span>
								<h3>Coordenação do curso</h3>
							</div>
						)}
					</div>
				</div>
			</Container>
		</section>
	);
};

export default InformacoesCurso;
